import React from 'react'

const SKELETON_SIZE = 'xxxxxxxxxxxxxxxxxxx'

export const skeletonLoading = (
  <span
    data-testid="delivery-pickup-skeleton-loading"
    className="lh-copy mocked light-silver text-loading"
  >
    {SKELETON_SIZE}
  </span>
)
